import { ChangeDetectorRef, Component, forwardRef, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { filter, takeUntil } from 'rxjs/operators';
import { CRAFT_ITEM_SMALL_ICONS } from 'src/app/core/dictionaries/craft-items-icons';
import { CraftItem } from 'src/app/core/models/craft.models';
import { CraftItemsBackendService } from 'src/app/core/services/backend/craft-items.backend.service';
import { ProductsStoreService } from 'src/app/core/store/services/products-store.service';
import { CraftFilterSelectComponent } from 'src/app/shared/components/craft-filter-select/craft-filter-select.component';

@Component({
  selector: 'craft-filter-linked-items-select',
  templateUrl: './craft-filter-linked-items-select.component.html',
  styleUrls: ['./craft-filter-linked-items-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CraftFilterLinkedItemsSelectComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class CraftFilterLinkedItemsSelectComponent extends CraftFilterSelectComponent implements OnInit {
  public productId: string;
  public items: CraftItem[];
  public openedItems = new Set<string>();
  public linkedItems = new Map<string, CraftItem>();

  public ICONS = CRAFT_ITEM_SMALL_ICONS;

  constructor(
    changeDetectorRef: ChangeDetectorRef, //
    private ims: CraftItemsBackendService,
    private productStore: ProductsStoreService,
  ) {
    super(changeDetectorRef);
  }

  public ngOnInit() {
    super.ngOnInit();

    this.productStore.selectedId$
      .pipe(
        filter((productId): productId is string => !!productId),
        takeUntil(this.destroy$),
      )
      .subscribe((productId) => {
        this.productId = productId;
      });
  }

  public toggleParent(parent: CraftItem, e?: MouseEvent) {
    e?.stopPropagation();
    if (this.openedItems.has(parent.guid)) {
      this.openedItems.delete(parent.guid);
      parent.children.forEach((c) => this.openedItems.delete(c.guid));
    } else {
      this.openedItems.add(parent.guid);
      if (parent.children.length === 0) {
        this.loadChildren(parent);
      }
    }
  }

  public onMenuOpened() {
    super.onMenuOpened();

    if (this.selectedSet.size === 0) {
      this.linkedItems.clear();
    } else if (this.productId) {
      this.ims
        .getItemsByIds(this.productId, Array.from(this.selectedSet.values()))
        .pipe(takeUntil(this.destroy$))
        .subscribe((linkedItems) => (this.linkedItems = linkedItems));
    }
  }

  public onMenuClosed() {
    super.onMenuClosed();
    this.openedItems.clear();
  }

  public clearSelected(e: MouseEvent) {
    e.stopPropagation();
    this.selectedSet.clear();
    this.linkedItems.clear();
    this.applyFilters();
  }

  public clearAndApply() {
    this.selectedSet.clear();
    this.linkedItems.clear();
    this.applyFilters();
  }

  protected changeSelectedItems(item: CraftItem) {
    const itemId = item.id;

    if (!this.selectedSet.has(itemId)) {
      this.linkedItems.set(itemId, item);
      this.selectedSet.add(itemId);
      this.select.next(item);
    } else {
      this.linkedItems.delete(itemId);
      this.selectedSet.delete(itemId);
      this.unselect.next(item);
    }
  }

  private loadChildren(parent: CraftItem) {
    if (!this.productId) return;

    this.ims
      .getItemsList(this.productId, parent.guid)
      .pipe(takeUntil(this.destroy$))
      .subscribe((children) => {
        parent.children = children;
      });
  }
}
